import { render, staticRenderFns } from "./LocusZoomPhewasPanel.vue?vue&type=template&id=711ef274&"
import script from "./LocusZoomPhewasPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomPhewasPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711ef274')) {
      api.createRecord('711ef274', component.options)
    } else {
      api.reload('711ef274', component.options)
    }
    module.hot.accept("./LocusZoomPhewasPanel.vue?vue&type=template&id=711ef274&", function () {
      api.rerender('711ef274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomPhewasPanel.vue"
export default component.exports